import './Legal.css';

export default function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <span className="legal-tag">Legal</span>
          <h1>Terms of Service</h1>
          <p className="legal-meta">Electradez LLC · Effective Date: March 14, 2025 · Colorado, USA</p>
        </div>

        <div className="legal-body">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>By creating an account or using the Electradez platform, you agree to these Terms of Service. If you do not agree, do not use the platform. These terms constitute a binding agreement between you and Electradez LLC, a Colorado limited liability company.</p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>Electradez is an online marketplace that allows users to list, browse, and connect with others regarding the sale of electric motorcycles, parts, and accessories. Electradez is a venue only — we are not a party to any transaction between buyers and sellers. All sales are conducted directly between users.</p>
          </section>

          <section>
            <h2>3. Eligibility</h2>
            <p>You must be at least 18 years old to use Electradez. By using the platform, you represent that you are at least 18 years old and have the legal capacity to enter into a binding agreement.</p>
          </section>

          <section>
            <h2>4. User Accounts</h2>
            <ul>
              <li>You are responsible for maintaining the confidentiality of your account credentials</li>
              <li>You are responsible for all activity that occurs under your account</li>
              <li>You must provide accurate and complete information when creating your account</li>
              <li>You may not create multiple accounts or use another user's account</li>
            </ul>
          </section>

          <section>
            <h2>5. Listings and Content</h2>
            <p>When you post a listing, you agree that:</p>
            <ul>
              <li>All information is accurate, truthful, and not misleading</li>
              <li>You own the item or are authorized to sell it</li>
              <li>The listing does not violate any applicable laws or regulations</li>
              <li>Photos and descriptions are your own or you have the right to use them</li>
              <li>You will not post stolen, counterfeit, or illegal items</li>
            </ul>
            <p>Electradez reserves the right to remove any listing at our sole discretion.</p>
          </section>

          <section>
            <h2>6. Prohibited Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Post false, misleading, or fraudulent listings</li>
              <li>Harass, threaten, or abuse other users</li>
              <li>Use the platform for any unlawful purpose</li>
              <li>Attempt to circumvent or manipulate the platform</li>
              <li>Scrape, crawl, or harvest data from the platform without permission</li>
              <li>Introduce malware or other harmful code</li>
              <li>Impersonate any person or entity</li>
            </ul>
          </section>

          <section>
            <h2>7. Transactions Between Users</h2>
            <p>Electradez is not involved in the actual transaction between buyers and sellers. We do not process payments, hold funds, or guarantee the completion of any sale. You are solely responsible for:</p>
            <ul>
              <li>Verifying the identity of the other party</li>
              <li>Inspecting items before purchase</li>
              <li>Arranging payment safely</li>
              <li>Completing any required legal transfer of ownership</li>
            </ul>
            <p>Electradez strongly recommends meeting in a safe public location and using secure payment methods.</p>
          </section>

          <section>
            <h2>8. Disclaimer of Warranties</h2>
            <p>THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. ELECTRADEZ LLC DOES NOT WARRANT THAT THE PLATFORM WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF VIRUSES. WE MAKE NO WARRANTY REGARDING THE ACCURACY, RELIABILITY, OR QUALITY OF ANY LISTINGS OR USER CONTENT.</p>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ELECTRADEZ LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE PLATFORM OR ANY TRANSACTION BETWEEN USERS. OUR TOTAL LIABILITY SHALL NOT EXCEED $100.</p>
          </section>

          <section>
            <h2>10. Indemnification</h2>
            <p>You agree to indemnify and hold harmless Electradez LLC, its members, officers, employees, and agents from any claims, damages, losses, or expenses (including reasonable attorney's fees) arising out of your use of the platform, your listings, or your violation of these Terms.</p>
          </section>

          <section>
            <h2>11. Governing Law</h2>
            <p>These Terms are governed by the laws of the State of Colorado, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of Colorado.</p>
          </section>

          <section>
            <h2>12. Changes to Terms</h2>
            <p>We may update these Terms at any time. Continued use of the platform after changes constitutes acceptance of the new Terms.</p>
          </section>

          <section>
            <h2>13. Contact</h2>
            <p><strong>Electradez LLC</strong><br />
            Colorado, USA<br />
            <a href="mailto:legal@electradez.com">legal@electradez.com</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
